import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const reportId = "duration-range";
const reportName = "Duração dos despachos";
const DispatchDuration = ({data, avgDispatchTime}) => {


  useEffect(() => {
    const values = data.map(i => i.qty);
    const labels = data.map(i => i.duration_range);

    GraphicUtils.barChart(reportId, values, labels, false);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, reportName);

  }, [data]);

  const min = avgDispatchTime > 1 ? "minutos" : "minuto";

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">{reportName}</span>
        { avgDispatchTime &&
          <span className="text-[14px] right-[32px] leading-[20px] absolute font-bold">Tempo médio: {avgDispatchTime} {min}</span>
        }
        <div className="mt-3" id={reportId}></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchDuration;